export enum BackgroundTaskErrorEnum {
  LAUNCHID_ALREADY_EXISTS,
  TASKID_NOT_EXISTS,
  MAX_ATTEMPTS_REACHED
}
